export const OPEN_POSITION_SL_PAST_LIQ_WARNING = `Stop Loss Order(s) have a trigger oracle price past the position's
						current liquidation price. Strongly consider editing order(s) to
						execute before liquidation begins. Open orders are force cancelled for
						accounts in liquidation.`;

export const OPEN_POSITION_SL_TOO_CLOSE_TO_LIQ_WARNING = `Stop Loss Order(s) have a trigger oracle price that is very close (<1%) to the position's
						current liquidation price. Due to oracle price jitter this can still result in liquidation. Strongly consider editing order(s) to
						execute farther away from the liquidation price. Open orders are force cancelled for
						accounts in liquidation.`;

export const NEW_ORDER_SL_PAST_LIQ_WARNING = `This order is a Stop Loss and has a trigger oracle price past the
														estimated liquidation price. Strongly consider
														adjusting your order to execute before liquidation begins.
														Open orders are force cancelled for accounts in
														liquidation.`;

export const NEW_ORDER_SL_TOO_CLOSE_TO_LIQ_WARNING = `This order is a Stop Loss and has a trigger oracle price that is very close (<1%) to the
														estimated liquidation price. Due to oracle price jitter this can still result in liquidation. Strongly consider
														adjusting your order to execute farther away from the liquidation price. Open orders are force cancelled for
														accounts in liquidation.`;

export const BRACKET_ORDER_SL_PAST_LIQ_WARNING = `Trigger Oracle Price for the attached Stop Loss order is past the current estimated
													liquidation price. Strongly consider adjusting it to
													execute before liquidation begins. Open orders are
													force cancelled for accounts in liquidation.`;

export const NEW_ORDER_TRIGGER_TOO_CLOSE_TO_LIMIT_WARNING = `The limit price on this new trigger order is very close (<1%) to the trigger price. Due to price jitters you probably want your limit price to be farther away from the trigger price to have a better chance of filling.`;

export const OPEN_POSITION_TRIGGER_TOO_CLOSE_TO_LIMIT_WARNING = `The limit price on this trigger order is very close (<1%) to the trigger price. Due to price jitters you probably want your limit price to be farther away from the trigger price to have a better chance of filling.`;
